// extracted by mini-css-extract-plugin
export default {"left":"styles_left__ZveQt","errorLogo":"styles_errorLogo__bbO-h","right":"styles_right__BVkvv","timer":"styles_timer__AvyUi"};